module.exports = __webpack_public_path__ + "static/media/catandbook-fall.3573b86e.gif";